import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import config from "../config/config";

const EditCardSlider = () => {

    const { id } = useParams();
    const [formData, setFormData] = useState({
        cardName: "",
        cardCollageTitle: "",
        linkname1: "",
        linkname2: "",
        linkname3: "",
    });

    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState("");
    const [loading, setLoading] = useState(true);

    const cardNameOptions = ["Engineering", "Management", "Arts", "Medical", "Design", "LAW"];

    useEffect(() => {
        // Fetch the existing card slider data
        const fetchCardSlider = async () => {
            try {
                const response = await axios.get(`${config.API_BASE_URL}/api/admin/get_cardsliderById/${id}`);
                setFormData(response.data.getCardsliderById);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching card slider:", error);
                setLoading(false);
            }
        };

        fetchCardSlider();
    }, [id]);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });

        setErrors({
            ...errors,
            [e.target.name]: "",
        });
    };

    const validate = () => {
        const newErrors = {};
        Object.keys(formData).forEach((key) => {
            if (!formData[key]) {
                newErrors[key] = "This field is required";
            }
        });
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await axios.put(`${config.API_BASE_URL}/api/admin/update_cardslider/${id}`, formData);
            alert("Card Slider updated successfully!");
        } catch (error) {
            console.error("Error updating card slider:", error.response?.data || error.message);
            alert("Something went wrong. Please try again.");
        }
    };

    if (loading) {
        return <div className="container mt-4">Loading...</div>;
    }

    return (
        <div className="container mt-5 pt-5">
       <div className="row">
        <div className="col-lg-2"></div>
        <div className="col-lg-10">
        <h2 className="mb-4">Edit Card Slider</h2>
            {successMessage && (
                <div className="alert alert-info" role="alert">
                    {successMessage}
                </div>
            )}
            <form onSubmit={handleSubmit}>
                {/* cardName dropdown */}
                <div className="mb-3">
                    <label htmlFor="cardName" className="form-label">Card Name</label>
                    <select
                        id="cardName"
                        name="cardName"
                        className={`form-select ${errors.cardName ? "is-invalid" : ""}`}
                        value={formData.cardName}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Select a card</option>
                        {cardNameOptions.map((option, index) => (
                            <option key={index} value={option}>{option}</option>
                        ))}
                    </select>
                    {errors.cardName && <div className="invalid-feedback">{errors.cardName}</div>}
                </div>

                {/* Other input fields */}
                <div className="mb-3">
                    <label htmlFor="cardCollageTitle" className="form-label">Card Collage Title</label>
                    <input
                        type="text"
                        className={`form-control ${errors.cardCollageTitle ? "is-invalid" : ""}`}
                        id="cardCollageTitle"
                        name="cardCollageTitle"
                        value={formData.cardCollageTitle}
                        onChange={handleChange}
                        required
                    />
                    {errors.cardCollageTitle && <div className="invalid-feedback">{errors.cardCollageTitle}</div>}
                </div>

                {["linkname1", "linkname2", "linkname3"].map((link, idx) => (
                    <div className="mb-3" key={link}>
                        <label htmlFor={link} className="form-label">Link Name {idx + 1}</label>
                        <input
                            type="text"
                            className={`form-control ${errors[link] ? "is-invalid" : ""}`}
                            id={link}
                            name={link}
                            value={formData[link]}
                            onChange={handleChange}
                            required
                        />
                        {errors[link] && <div className="invalid-feedback">{errors[link]}</div>}
                    </div>
                ))}

                <button type="submit" className="btn btn-primary">Update</button>
            </form>
        </div>
       </div>
        </div>
    );
};

export default EditCardSlider;
